<template>
  <div class="sktooltip-container">
    <div ref="trigger" class="cursor-pointer" @mouseover="showTooltip = true" @mouseout="showTooltip = false">
      <slot></slot>
    </div>
    <div ref="tooltip" class="sktooltip text-xs" v-show="showTooltip" :style="{ top: triggerY + 'px', left: triggerX + 'px' }">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SKTooltip",
  data() {
    return {
      showTooltip: false,
      triggerX: 0,
      triggerY: 0,
    };
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  mounted() {
    document.body.appendChild(this.$refs.tooltip)
  },
  updated() {
    if (this.showTooltip) {
        let trigger = this.$refs.trigger.getBoundingClientRect()
        let tooltip = this.$refs.tooltip.getBoundingClientRect()
        this.triggerX = trigger.left + window.scrollX - ((tooltip.width - trigger.width) / 2)
        this.triggerY = trigger.top + window.scrollY - tooltip.height - 4
    }
  }
};
</script>

<style>
.sktooltip {
    @apply absolute text-white p-1 rounded-md bg-black;
    z-index: 99999;
    max-width: 16rem;
}
</style>